import React from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { translate } from "react-i18next";
import { withStyles } from "@material-ui/styles";
import { styles } from "./styles";

class TableHeader extends React.Component {
  handleHeaderClick(event) {
    this.props.select(this.props.fileKey);
  }

  render() {
    const { t, classes } = this.props;
    return (
      <TableRow>
        <TableCell className={classes.tableHeader}>{t("name")}</TableCell>
        <TableCell className={classes.tableHeader}>{t("size")}</TableCell>
        <TableCell className={classes.tableHeader}>{t("created_at")}</TableCell>
        <TableCell className={classes.tableHeader}>{t("action")}</TableCell>
      </TableRow>
    );
  }
}

export default translate("translations")(withStyles(styles)(TableHeader));
